/**
 * 手动分页
 * @param arr 原数组数据
 * @param size 一页数量
 * @returns {any[]|*[]}
 */
const sliceArray=(arr, size = 10)=> {
    if (arr.length > size) {
        //
        const index= Math.ceil(arr.length / size); // 预计需要的二维数组的长度
        let newArr= Array(index).fill([]); // 初始化一个二维数组
        let end= 0; // 每次分页最后的索引
        // 循环二维数据取值
        for (let i = 0; i < index; i++) {
            end = i * size + size;
            if (end > arr.length) {
                end = (arr.length % end) + i * size;
            }
            newArr[i] = arr.slice(i * size, end);
        }
        return newArr;
    } else {
        return [arr];
    }
}

export {
    sliceArray
}
